<!-- @format -->
<script lang="ts">
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import type { ManageAPI } from "~/manage-api/types";
  import type { StoresLunchItem } from "./utils";
  import LunchItem from "./LunchItem.svelte";
  import MediumLayout from "../layouts/MediumLayout.svelte";

  export let request_store_key: StoresKey;
  export let currentLocale: string = 'en';
  
  type EnhancedLunchItem = {
    menu: StoresLunchItem;
    store: ManageAPI.Store | undefined;
    href: string;
  };
  
  export let lunchMenus: StoresLunchItem[] = [];

  const { T, stores, reverse_router, scdata } = getStoresContext(request_store_key);
  $: t = $T;

  let selected_store_name = '';
  
  $: hasLunchMenus = lunchMenus.length > 0;
  
  let filter_lunchMenus: EnhancedLunchItem[] = [];
  
  // Find matching store for each lunch menu
  $: enhancedLunchMenus = lunchMenus.map(menu => {
    const storeIdToFind = typeof menu.store.id === 'string' ? parseInt(menu.store.id, 10) : menu.store.id;
    const store = $stores.find(s => s.id === storeIdToFind);
    const href = store ? $reverse_router.routeStore(store, $scdata) : "/";
    return { menu, store, href };
  });
  
  // Search
  $: search_term = selected_store_name;
  $: {
    if (enhancedLunchMenus.length > 0) {
      if (search_term) {
        filter_lunchMenus = enhancedLunchMenus.filter(
          (item) =>
            item.menu.store.name.toLowerCase().includes(search_term.toLowerCase()) ||
            (item.menu.lunchMenu?.toLowerCase() || '').includes(search_term.toLowerCase())
        );
      } else {
        filter_lunchMenus = enhancedLunchMenus;
      }
      filter_lunchMenus = filter_lunchMenus.sort((a, b) => 
        a.menu.store.name.localeCompare(b.menu.store.name, currentLocale, { sensitivity: 'base' })
      );
    } else {
      filter_lunchMenus = [];
    }
  }
  
  function search(e: Event): void {
    const target = e.currentTarget as HTMLInputElement;
    search_term = target instanceof HTMLInputElement ? target.value : '';
  }
</script>

<MediumLayout {request_store_key}>
  <div class="lunch-list">
    <div class="d-flex justify-content-between align-items-center mb-4">
      {#if hasLunchMenus}
        <div class="input-group toggle-btn-group">
          <input
            type="text"
            class="form-control"
            placeholder={t`find-a-lunch-place`}
            aria-label="haku-sana"
            on:input={search}
          />
          <div class="input-group-append">
            <button class="purple-button"><i class="bi bi-search" /></button>
          </div>
        </div>
      {/if}
    </div>

    {#if filter_lunchMenus && filter_lunchMenus.length}
      <div class="row">
        {#each filter_lunchMenus as { menu, store, href } (menu.store.id)}
          <LunchItem {menu} {store} {href} {t} />
        {/each}
      </div>
    {:else}
      <div class="row">
        <div class="col-12 text-center py-5">
          <p class="no-menus-message">{t`no-lunch-menus-found-for-today`}</p>
        </div>
      </div>
    {/if}
  </div>
</MediumLayout>

<style lang="scss">
  .toggle-btn-group {
    @media screen and (min-width: 768px) {
      width: 300px;
    }
    label input {
      display: none; /* Hide the default checkbox */
    }
    input.form-control {
      border-radius: 0;
      background-color: var(--color-accent-secondary-light);
      border: 1px solid var(--color-accent-secondary-light);
    }
    input.form-control:focus {
      color: #212529;
      background-color: '';
      border-color: '';
      outline: 0;
      box-shadow: none;
    }
  }
  
  .no-menus-message {
    font-size: 1.2rem;
    color: var(--color-accent-primary-text);
  }
</style>